import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import messages from "../messages";
import { ItemLine } from "./ItemLine";
import { FormatedPrice } from "./FormatedPrice";
import { SubItem } from "./SubItem";
import { useCurrentUser } from "@modules/Authentication/hooks/useCurrentUser";
import { Money } from "@Shared/Components/Money/Money";

export const ServiceFees = ({
  preview,
  itemFeesCents,
  billingUnit,
  currency,
  billingCount,
  totalExpensesFees,
  serviceFeeRate,
}) => {
  const MESSAGES = {
    flat: messages.flatRateFee,
    hour: messages.hourlyRateFee,
    day: messages.dailyRateFee,
  };

  const { currentUser } = useCurrentUser({
    includes: ["currentSubscription"],
  });

  return (
    !currentUser?.currentSubscription && (
      <ItemLine title={<FormattedMessage {...messages.serviceFee} />}>
        <SubItem
          title={
            <FormattedMessage
              {...MESSAGES[billingUnit]}
              values={{
                feeRate: Number(serviceFeeRate),
              }}
            />
          }
          price={
            <FormatedPrice
              preview={preview}
              priceCents={itemFeesCents}
              currency={currency}
              billingUnit={billingUnit}
              billingCount={billingCount}
              rateAmount={itemFeesCents / billingCount / 100}
            />
          }
        />
        {totalExpensesFees > 0 && (
          <SubItem
            title={
              <FormattedMessage
                {...messages["otherExpensesFee"]}
                values={{
                  feeRate: Number(serviceFeeRate),
                }}
              />
            }
            price={<Money cents={totalExpensesFees} currency={currency} />}
          />
        )}
      </ItemLine>
    )
  );
};
